import angular from 'angular';
import 'bootstrap/dist/css/bootstrap.css';
import './app.css';
import uirouter from 'angular-ui-router';
import services from "./services";
import inspinia from "./inspinia";
import auth from "./auth";
import dashboard from "./customer-portal/dashboard";
import novinky from "./novinky";
import poziadavky from "./customer-portal/poziadavky";
import decimal from "./decimal";
import ChosenCombo from "./util/ChosenCombo.js"
import PrilohaField from "./util/PrilohaField.js"
import Prilohy from "./util/Prilohy.js"
import ExcelImportModalCtrl from "./util/ExcelImportModalCtrl.js"
import Spinner from "./util/Spinner.js"
import ErrorMessage from "./util/ErrorMessage.js"
import Rating from "./util/Rating.js";
import moment from "moment";
import "moment/locale/sk.js";
import "angular-ui-date";
import "angular-ui-bootstrap";
import "jquery-ui/themes/base/all.css";
import {array_remove} from "./util";
import "angular-i18n/sk";
import "ng-infinite-scroll";
import "ngsweetalert";
import "sweetalert";
import "sweetalert/dist/sweetalert.css";
import "angular-chart.js";
import "angular-drag-scroll";
import "lodash";
import "angular-simple-logger";
import "angular-google-maps";
import fixedHeaders from "./fixed-headers";
import ErrorService from "./util/ErrorService.js";
import prevadzkovaKniha from "./prevadzkova-kniha";
import DataTable from "./DataTable";

moment.locale("sk");
//import uiselect from "ui-select";
//import "ui-select/dist/select.css";
const MODULE_NAME = 'antes-customer-portal';
const APPVERSION = "2.8.41";
const HELPDESK = "helpdesk@biznet.sk";

var ServerError = function ServerError (err, method) {
    this.type = err.type;
    this.message = err.message;
    this.hierarchy = err.hierarchy;
    this.method = method;
    if(err.cause){
        this.cause = new ServerError(err.cause);
    }
    this.trace = err.trace;
    this.data = err;
};

ServerError.prototype.is = function(cls) {
    for(var i in this.hierarchy){
        if(this.hierarchy[i] == cls){
            return true;
        }
    }
    return false;
};

angular.module(MODULE_NAME, [
    uirouter, decimal,
    novinky,
    dashboard, services, inspinia,
    poziadavky, prevadzkovaKniha,
    "ui.date", "infinite-scroll", auth, 'ng-drag-scroll',
    "ui.bootstrap",
    "ngSweetAlert", "chart.js", fixedHeaders, DataTable
])
    .directive("chosenCombo", ChosenCombo)
    .directive("priloha", PrilohaField)
    .directive("prilohy", Prilohy)
    .directive("spinner", Spinner)
    .directive("error", ErrorMessage)
    .directive("rating", Rating)
    .service("ErrorService", ErrorService)
    .service("ZakaznikService", function($q) {
        return {
            list(){ return $q.resolve([]); }
        }
    })
    .controller("ExcelImportModalCtrl", ExcelImportModalCtrl)
    .filter('bytes', function() {
        return function(bytes, precision) {
            if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
            if (typeof precision === 'undefined') precision = 1;
            var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'],
                number = Math.floor(Math.log(bytes) / Math.log(1024));
            return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) +  ' ' + units[number];
        }
    })
    .value("config", {
        api: "../proxy-api.php",
        helpdesk: HELPDESK,
        appversion: APPVERSION
    })
    .run(function(ErrorService){
      window.GlobalErrorHandler = function(err, text){ return ErrorService.showError(err, text); }
    })
    .run(function($rootScope, $window){
        $rootScope.moment = moment;
        $rootScope.array_remove = array_remove;
        $rootScope.dateOptions = {
            dateFormat:"dd.mm.yy",
            firstDay: 1,
            dayNamesMin: ["Ne", "Po", "Ut", "St", "Št", "Pi", "So"]
        }
        $rootScope.Math = Math;
        $rootScope.back = function(){
            $window.history.back();
        }
        $rootScope.APPVERSION = APPVERSION;

        (function() {
            var beforePrint = function() {
                $rootScope.$broadcast("print");
            };

            var afterPrint = function() {
            };

            if (window.matchMedia) {
                var mediaQueryList = window.matchMedia('print');
                mediaQueryList.addListener(function(mql) {
                    if (mql.matches) {
                        beforePrint();
                    } else {
                        afterPrint();
                    }
                });
            }

            window.onbeforeprint = beforePrint;
            window.onafterprint = afterPrint;
        }());


    })
    .factory("server", function(config, $http){
        var token = null;

        var getRequest = function(method, params){
            return {
                method: method,
                params: params,
                token: token
            }
        }

        var getRequestUrl = function(method, params){
            return config.api+"?"+(JSON.stringify(getRequest(method, params)));
        }

        var fn = function(method, params){
            console.log("calling",method,params);
            return $http.post(config.api, getRequest(method, params)).then(function(response){
                if(response.data.error && response.data.error.type == "CSRFException"){
                    console.log("repeat request with token");
                    token = response.data.result.token;
                    return fn(method, params);
                }
                if(response.data.out){
                    console.log("output", response.data.out);
                }
                if(response.data.error){
                    console.log("application error", response.data.error);
                    throw new ServerError(response.data.error, method);
                }
                if(typeof response.data === 'string'){
                    console.log("server error", response.data);
                    throw "ServerError " + response.data;
                }
                console.log(method+"(): result", response.data.result);
                return response.data.result;
            },function(err){
                throw ["Conection error",err];
            });
        };

        fn.getRequestUrl = getRequestUrl;

        return fn;

    });

export default MODULE_NAME;


if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function(predicate) {
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }
            var o = Object(this);
            var len = o.length >>> 0;
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }
            var thisArg = arguments[1];
            var k = 0;
            while (k < len) {
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                k++;
            }
            return undefined;
        }
    });
}


// WEBPACK FOOTER //
// ./src/app.customer-portal.js